/**
 * 开关（switch）。
 *
 * 尺寸 52×26、极简线条风格（用户从三个候选里选的中档）：
 * 关 = 灰色细边框 + 灰点靠左；开 = 项目蓝边框 + 蓝点靠右。
 *
 * 只用于「开 / 关」语义。多选（列中心、标签多选、行选择）继续用 checkbox，
 * 单元格里的布尔值（boolean/rating 列）另算，不要套这个组件。
 */
export default function Switch({
  checked,
  onChange,
  disabled,
  label,
  title,
}: {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  /** 无障碍名称（视觉上通常已有旁边文字，这里只给读屏用） */
  label?: string
  title?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={title}
      disabled={disabled}
      className={`sw${checked ? ' sw--on' : ''}`}
      onClick={() => {
        if (disabled === true) return
        onChange(!checked)
      }}
    >
      <span className="sw__dot" />
    </button>
  )
}
